import { useSession } from 'next-auth/react';
import { useRouter } from 'next/router';
import { useEffect } from 'react';
import {
  analyticsActivity,
  analyticsHeartbeat,
  setAnalyticsPage,
  startAnalytics,
} from '../../utils/web-analytics';

export default function WebAnalytics() {
  const router = useRouter();
  const { data, status } = useSession();
  useEffect(() => {
    if (!router.isReady || status === 'loading') return;
    setAnalyticsPage(router.pathname);
    void startAnalytics(
      process.env.NODE_ENV === 'development' ? data?.accessToken : undefined,
    );
  }, [router.isReady, router.pathname, data?.accessToken, status]);
  useEffect(() => {
    const heartbeat = analyticsHeartbeat;
    const visibility = () => {
      heartbeat();
      if (document.visibilityState === 'visible') analyticsActivity();
    };
    const interval = setInterval(heartbeat, 20000);
    document.addEventListener('visibilitychange', visibility);
    window.addEventListener('pagehide', heartbeat);
    window.addEventListener('pointerdown', analyticsActivity, {
      passive: true,
    });
    window.addEventListener('keydown', analyticsActivity, { passive: true });
    window.addEventListener('scroll', analyticsActivity, { passive: true });
    return () => {
      clearInterval(interval);
      document.removeEventListener('visibilitychange', visibility);
      window.removeEventListener('pagehide', heartbeat);
      window.removeEventListener('pointerdown', analyticsActivity);
      window.removeEventListener('keydown', analyticsActivity);
      window.removeEventListener('scroll', analyticsActivity);
    };
  }, []);
  return null;
}
